import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { provideIMCAuth } from './auth';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideIMCAuth({
      apiUrl: environment.apiUrl,
      azureAD: {
        clientId: 'd9775ed3-19e3-4273-8a30-1533d61aa27c',
        tenantId: '389e4131-83ac-4189-909d-a0a3def85738',
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
      },
      sessionTimeoutMinutes: 120,
      storagePrefix: 'callavoidance_auth',
      loginRoute: '/login',
      requireAdmin: false
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    })
  ]
};
